import React, { useEffect } from "react";
import { GetStaticProps, NextPage } from "next";
import axios from "axios";
import { BlogCardType } from "@/components/page-modules/blog/data/blog.types";
import { BlogContainer } from "@/components/page-modules/blog/BlogContainer";
import { ENDPOINTS } from "@/api/routing";
import { BLOG_REVALIDATE_TYPE, BUILDER_CONTENT_MAIN_CSS } from "@/constant";
import SeoHeader from "@/components/common/Seo/SeoHeader";
import { useSolutionsSelect } from "@/states/solution.state";
const BlogDetailPage: NextPage<BlogCardType> = ({
  blogData
}) => {
  const productionMode = process.env.NEXT_PUBLIC_ENVIRONMENT;
  const {
    setSolutionsType
  } = useSolutionsSelect();
  const contentBuilderCSS = [{
    id: "content",
    rel: "stylesheet",
    href: `${process.env.NEXT_PUBLIC_API_URL}${BUILDER_CONTENT_MAIN_CSS}`,
    className: "rel"
  }];
  useEffect(() => {
    if (blogData.qrType) {
      setSolutionsType({
        solutionSelectedType: blogData.qrType
      });
    }
  }, [blogData?.qrType]);
  return <>
      <SeoHeader seoTitle={blogData?.seoTitle} seoDescription={blogData?.seoDescription} seoKeywords={blogData?.seoKeywords} imageUrl={blogData?.image} metaTags={[{
      property: "author",
      content: blogData?.author?.name
    }]} contentBuilderCSS={contentBuilderCSS} noIndex={productionMode !== "production"} data-sentry-element="SeoHeader" data-sentry-source-file="index.tsx" />
      {blogData && <BlogContainer blogData={blogData} />}
    </>;
};
export default BlogDetailPage;
export async function getStaticPaths() {
  const blogData = await axios.get(ENDPOINTS.GET_BLOGS(400));
  return {
    paths: blogData?.data?.data?.map((c: Record<string, any>): string => `/${c.slug}`),
    fallback: "blocking"
  };
}
export const getStaticProps: GetStaticProps = async ({
  params,
  locale
}) => {
  try {
    const blogData = await axios.get(ENDPOINTS.GET_BLOG_BY_SLUG(params!.slug as string));
    return {
      props: {
        blogData: blogData.data.data,
        messages: (await import(`@/messages/qrcodecreator/${locale || "en"}/home.json`)).default
      },
      revalidate: BLOG_REVALIDATE_TYPE
    };
  } catch (error: unknown) {
    return {
      notFound: true,
      revalidate: BLOG_REVALIDATE_TYPE
    };
  }
};